import React, { createContext, useContext, useMemo, useState } from "react";
import { IClient } from "@utils/interfaces";

type CustomerStatus = "idle" | "loading" | "loaded" | "error";

interface AppointmentPriceContextValue {
  dataCustomer: IClient | null;
  customerStatus: CustomerStatus;
  setDataCustomer: (data: IClient | null) => void;
  setCustomerStatus: (status: CustomerStatus) => void;
}

const AppointmentPriceContext = createContext<AppointmentPriceContextValue>(
  {} as AppointmentPriceContextValue
);

const AppointmentPriceProvider: React.FC = ({ children }) => {
  const [dataCustomer, setDataCustomer] = useState<IClient | null>(null);
  const [customerStatus, setCustomerStatus] = useState<CustomerStatus>("idle");

  const value = useMemo(
    () => ({
      dataCustomer,
      customerStatus,
      setDataCustomer,
      setCustomerStatus,
    }),
    [dataCustomer, customerStatus]
  );

  return (
    <AppointmentPriceContext.Provider value={value}>
      {children}
    </AppointmentPriceContext.Provider>
  );
};

const useAppointmentPriceContext = () => {
  const context = useContext(AppointmentPriceContext);
  if (!context || Object.keys(context).length === 0) {
    throw new Error(
      "useAppointmentPriceContext deve ser utilizado dentro de um AppointmentPriceProvider"
    );
  }
  return context;
};

export type { CustomerStatus };
export { useAppointmentPriceContext, AppointmentPriceProvider };
